module.exports = __webpack_public_path__ + "img/Tabar.e7ff3619.png";